import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiStateSrefModule } from '@fi-app/shared/fi-state-proxy/state-sref/state-sref.module';
import { FiStateSrefAccessDirective } from './state-sref-access.directive';

@NgModule({
    imports: [CommonModule, FiStateSrefModule],
    declarations: [FiStateSrefAccessDirective],
    exports: [FiStateSrefAccessDirective],
})
export class FiStateSrefAccessModule {}
